export default __webpack_public_path__ + "static/media/avatar_me.deef3212.jpg";